import { Action, createFeatureSelector, createReducer, on } from '@ngrx/store';

import { ErrorMessage } from 'app/shared/error-handling';

import { KpiNotificationSettings } from '../kpi-notification-settings.model';
import * as KpiNotificationActions from './kpi-notification-settings.actions';

export interface State {
    kpiNotificationSettings: KpiNotificationSettings;
    loaded: boolean;
    error: ErrorMessage | null;
}

export const initialState: State = {
    kpiNotificationSettings: null,
    loaded: false,
    error: null,
};

const reducer = createReducer<State>(
    initialState,
    on(KpiNotificationActions.loadKpiNotificationSettings, (_state): State => {
        return {
            ...initialState,
        };
    }),
    on(
        KpiNotificationActions.loadKpiNotificationSettingsSuccess,
        (state, { reportId, kpiNotificationSettings }): State => {
            kpiNotificationSettings.reportId = reportId;

            return {
                ...state,
                kpiNotificationSettings,
                loaded: true,
            };
        },
    ),

    on(KpiNotificationActions.loadKpiNotificationSettingsError, (state: State, { error }): State => {
        return {
            ...state,
            loaded: true,
            error,
        };
    }),
    on(
        KpiNotificationActions.saveKpiNotificationSettingsSuccess,
        (state: State, { kpiNotificationSettings }): State => {
            return {
                ...state,
                kpiNotificationSettings,
                loaded: true,
            };
        },
    ),
    on(KpiNotificationActions.saveKpiNotificationSettingsError, (state: State, { error }): State => {
        return {
            ...state,
            loaded: true,
            error,
        };
    }),
);

export function kpiNotificationSettingsReducer(state: State | undefined, action: Action) {
    return reducer(state, action);
}

export const getKpiNotificationSettingsState = createFeatureSelector<State>('kpi-notification-settings');
